import React from 'react';

export const DefaultUserUpdatable = {statistics: {}, credit: undefined, last_update: undefined};

const UserUpdatableContext = React.createContext();

export default UserUpdatableContext;